export const preCleanMarkup = (markup: string): string => {
  return markup
    .replace(/\r\n/g, ' ')
    .replace(/\n/g, '')
    .replace(/\r/g, '')
    .replace(/\t/g, '')
    .replace(/\u200b/g, '');
};
